import React from 'react';

import { flagStyles } from '../settings';

const SvgBV = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-768px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBV;
